import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'core/constants/routes';
import { NamespacesList } from 'core/enums/common';

import { ReactComponent as Success } from 'assets/icons/success.svg';

export const ResetSuccess = () => {
	const { t: modalsTranslate } = useTranslation(NamespacesList['modals']);

	const navigate = useNavigate();
	const redirectToLogin = () => {
		navigate(ROUTES.LOGIN);
	};

	return (
		<Box
			className="rtl-able"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				alignSelf: 'center',
				width: { xs: '100%', sm: '438px' },
				margin: '48px 0',
			}}
		>
			<Success />

			<Typography
				variant="h3"
				sx={{
					fontSize: '24px',
					fontWeight: '700',
					marginTop: { xs: '16px', sm: '32px' },
					textAlign: 'center',
				}}
			>
				{modalsTranslate('resetEmailSuccessModal.titlePartOne')} <br />{' '}
				{modalsTranslate('resetEmailSuccessModal.titlePartTwo')}
			</Typography>

			<Typography sx={{ color: '#9FA6B3', marginTop: '8px', textAlign: 'center' }}>
				{modalsTranslate('resetEmailSuccessModal.descriptionPartOne')}
				<br />
				{modalsTranslate('resetEmailSuccessModal.descriptionPartTwo')}
			</Typography>

			<Button
				sx={{
					height: '44px',
					width: { xs: '100%', sm: '438px' },
					borderRadius: '8px',
					textTransform: 'none',
					fontSize: '16px',
					fontWeight: '700',
					marginTop: '24px',
				}}
				variant="contained"
				color="primary"
				onClick={redirectToLogin}
			>
				{modalsTranslate('resetEmailSuccessModal.confirm')}
			</Button>
		</Box>
	);
};
